import { BackendModel, BackendService } from './backend.service';
import { DecimalPipe } from '@angular/common';


export class Precio extends BackendModel {

  static path = '/precios/';

  lastSeller: number;
  lastBuyer: number;
  currencie: String;
  variation: DecimalPipe;
  volumen: DecimalPipe;

  constructor(protected backendService: BackendService, model?: Precio) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/precio.model.ts